<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <h1 class="mb-4">Terms of Service</h1>
        <p class="text-muted mb-4">Last updated: September 21, 2025</p>
        
        <section class="mb-4">
          <p><strong>1. Acceptance of Terms</strong></p>
          <p>By accessing and using kikuflow, you accept and agree to be bound by the terms and provision of this agreement.</p>
        </section>

        <section class="mb-4">
          <p><strong>2. Use License</strong></p>
          <p>Permission is granted to temporarily access kikuflow for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
          <ul>
            <li>Modify or copy the materials</li>
            <li>Use the materials for commercial purposes or for public display</li>
            <li>Attempt to reverse engineer any software contained on the service</li>
            <li>Remove any copyright or other proprietary notations</li>
          </ul>
        </section>

        <section class="mb-4">
          <p><strong>3. User Responsibilities</strong></p>
          <p>You are responsible for:</p>
          <ul>
            <li>Maintaining the confidentiality of your account</li>
            <li>All activities that occur under your account</li>
            <li>Ensuring your use complies with applicable laws</li>
            <li>Providing accurate and complete information</li>
          </ul>
        </section>

        <section class="mb-4">
          <p><strong>4. Service Availability</strong></p>
          <p>We strive to maintain service availability but do not guarantee uninterrupted access. We may suspend or terminate services for maintenance, updates, or other operational reasons.</p>
        </section>

        <section class="mb-4">
          <p><strong>5. Limitation of Liability</strong></p>
          <p>In no event shall kikuflow or its suppliers be liable for any damages arising out of the use or inability to use the service, even if we have been notified of the possibility of such damage.</p>
        </section>

        <section class="mb-4">
          <p><strong>6. Termination</strong></p>
          <p>We may terminate or suspend your account immediately, without prior notice, for conduct that we believe violates these Terms of Service or is harmful to other users or the service.</p>
        </section>

        <section class="mb-4">
          <p><strong>7. Changes to Terms</strong></p>
          <p>We reserve the right to modify these terms at any time. Your continued use of the service after any changes constitutes acceptance of the new terms.</p>
        </section>

        <section class="mb-4">
          <p><strong>8. Contact Information</strong></p>
          <p>If you have any questions about these Terms of Service, please contact us through our support channels.</p>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Terms of service content - static implementation for MVP
</script>